import { Fragment, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { read, utils, writeFileXLSX } from 'xlsx'
import SectionItem from '@components/Layout/SectionItem/SectionItem'
import { useIntl } from 'react-intl'
import SectionItemContainer from '@/app/components/Layout/SectionItemContainer/SectionItemContainer'
import {
    LuxButton,
    LuxTextInput,
    LuxDataTable,
    LuxSelect,
    Color,
    useWindowResize,
    LUX_INPUT_TYPE,
} from '@lux/wardrobe-lib'
import { columns, mappingSmartFilter } from './table-config'
import { FiltersService } from '@/app/services/FiltersService'
import { FILTERS_REDUCER_NAMESPACE } from '@/app/redux/reducers/filters'
import {
    getDistributionLists,
    saveDistributionList,
    setStoreIdList,
    downloadStoreList,
} from '@/app/redux/actions/filters'
import DialogDownloadList from '../../UI/Dialogs/DialogDownloadList/DialogDownloadList'
import { useTableConfig } from '@Techedge/smart-shared'
import { LazyParams, LazyParamsFilters } from '@/app/models/distribution'
import {
    getDistributionFiltersBody,
    setSmartFiltersOptions,
    getInitialFilters,
    setInitialFilters,
    setSmartFiltersValue,
} from './distribution-utils'
import { DISTRIBUTION_REDUCER_NAMESPACE } from '@/app/redux/reducers/distribution'
import './Distribution.scss'
import DialogUploadList from '../../UI/Dialogs/DialogUploadList/DialogUploadList'
import DialogExportTemplate from '../../UI/Dialogs/DialogExportTemplate/DialogExportTemplate'

const DistributionList = (props: any) => {
    const {
        form,
        onSetForm,
        onSave,
        storeIdList,
        distributionLists,
        afterTableTemplate,
        beforeTableTemplate,
        customStoreList,
        disableSelection,
        disableHeaderActions,
        isReadOnly,
        hideDistributionList,
        disableFixedFilters,
        customColumnConfig,
        isEdit,
        getDistributionLists,
        gettingDistributionList,
        tableConfigId,
        smartFilter,
        setSmartFilter,
        mappingChanges,
        filtersOptionsMap,
        disableSmartFilters,
        setExternalFilters,
        externalFilters,
        children,
    } = props

    const intl = useIntl()

    const isMobile = useWindowResize()

    const componentClass = 'smart-new-activity-distribution'

    const [loading, setLoading] = useState(false)

    const [filteredStores, setFilteredStores] = useState<any[]>([])

    const [showDialogDownloadList, setShowDialogDownloadList] = useState(false)

    const [checked, setChecked] = useState(false)
    const [showDynamicFilter, setShowDynamicFilter] = useState(false)

    const [selectAll, setSelectAll] = useState(false)
    const [isInit, setIsInit] = useState(true)

    const [totalStores, setTotalStores] = useState(0)
    const [localCustomStoreListLength, setLocalCustomStoreListLength] = useState(
        customStoreList?.length
    )
    const [totalSelectedStores, setTotalSelectedStores] = useState(storeIdList.length)
    const [lastFieldFilter, setLastFieldFilter] = useState<string | undefined>(undefined)
    const [lazyParams, setLazyParams] = useState<LazyParams>({
        first: 0,
        rows: 5,
        page: 0,
        sortField: 'store_id',
        sortOrder: 1,
        filters: setInitialFilters({ filtersOptionsMap, smartFilter, externalFilters }),
        storeIdList: customStoreList || [],
    })

    const [columnFilters, setColumnFilters] = useState<Record<any, LazyParamsFilters>>(
        setInitialFilters({
            filtersOptionsMap,
            smartFilter,
            externalFilters,
        })
    )
    const [storesToImport, setStoresToImport] = useState<any[]>([])
    const [showDialogUploadList, setShowDialogUploadList] = useState<boolean>(false)
    const [showDialogExportTemplate, setShowDialogExportTemplate] = useState<boolean>(false)
    const abortControllerRef = useRef(null)

    const selectionFilters = [
        {
            label: intl.formatMessage({
                id: 'modals.activity.create.distribution.action.show_all',
                defaultMessage: 'Show all',
            }),
            onClick: () => onSelectionFilters('show_all'),
        },
        {
            label: intl.formatMessage({
                id: 'modals.activity.create.distribution.action.show_selected',
                defaultMessage: 'Show selected',
            }),
            onClick: () => onSelectionFilters('show_selected'),
        },
        {
            label: intl.formatMessage({
                id: 'modals.activity.create.distribution.action.show_unselected',
                defaultMessage: 'Show unselected',
            }),
            onClick: () => onSelectionFilters('show_unselected'),
        },
    ]

    const onExportTemplate = () => {
        const ste = [
            {
                store_id: '3024',
            },
            {
                store_id: '3025',
            },
            {
                store_id: '3026',
            },
            {
                store_id: '0001',
            },
            {
                store_id: '5422',
            },
        ]
        const ws = utils.json_to_sheet(ste, { skipHeader: true })
        const wb = utils.book_new()
        utils.book_append_sheet(wb, ws, 'Data')
        writeFileXLSX(wb, 'ExportTemplate.xlsx')
        setShowDialogExportTemplate(false)
    }

    const onUploadList = (e: any) => {
        const file = e.target?.files?.[0] || e.files?.[0]
        const reader = new FileReader()
        reader.onload = (r: any) => {
            const wb = read(r.target.result, { type: 'array' })
            const wsname = wb.SheetNames[0]
            const ws = wb.Sheets[wsname]
            const data = utils.sheet_to_json(ws, { header: 1 })
            const tmpStoresToImport = data.map((store: any) => {
                for (const store_id of Object.values(store)) {
                    return store_id.toString().padStart(4, '0')
                }
            })
            setStoresToImport(tmpStoresToImport)
        }
        reader.readAsArrayBuffer(file)
        setShowDialogUploadList(false)
    }

    const initStoreList = (lazyParams: LazyParams, isInit?: boolean) => {
        if (
            lazyParams.filters.store_name.value?.length > 2 ||
            !lazyParams.filters.store_name.value
        ) {
            setLoading(true)
            if (abortControllerRef.current) {
                abortControllerRef.current.abort()
            }
            let newController: AbortController = new AbortController()
            abortControllerRef.current = newController
            FiltersService.GetStoreList({
                mode: 'standard',
                coneOfVision: true,
                groupedFields: 'all',
                page: lazyParams.page + 1,
                pageSize: lazyParams.rows,
                tableFilters: getDistributionFiltersBody(
                    !!lastFieldFilter
                        ? {
                              ...columnFilters,
                              [lastFieldFilter]: {
                                  ...lazyParams.filters[lastFieldFilter],
                              },
                              storeIdList: { value: lazyParams.storeIdList },
                          }
                        : lazyParams.filters
                ),
                sort: {
                    field: lazyParams.sortField,
                    type: lazyParams.sortOrder > 0 ? 'asc' : 'desc',
                },
                controller: newController,
            })
                .then((res: any) => {
                    if (res?.data) {
                        const _data = res.data
                        setFilteredStores(_data?.stores)
                        setTotalStores(_data?.storesCount)
                        // Aggiorno il totale degli store selezionabili solo in fase iniziale e non ogni volta che applico i filtri della tabella
                        // escludo storeIdList dal check per evitare che venga considerato un filtro
                        if (
                            Object.entries(lazyParams.filters).every(([key, filter]) => {
                                if (!key || key === 'storeIdList') return true
                                const value = filter?.value
                                return !value || (Array.isArray(value) && value.length === 0)
                            })
                        ) {
                            setTotalSelectedStores(_data?.storesCount)
                        }
                        try {
                            const clmnFilter = getInitialFilters(
                                _data,
                                columnFilters,
                                lastFieldFilter
                            )
                            if (!!Object.keys(smartFilter || {}).length) {
                                setColumnFilters(
                                    setSmartFiltersValue(smartFilter, clmnFilter, lastFieldFilter)
                                )
                            } else {
                                setColumnFilters(clmnFilter)
                                setExternalFilters && setExternalFilters(clmnFilter)
                            }
                        } finally {
                            // Caso in cui si deve caricare la lista degli store di un parent
                            // (sub-folder o thread) e l'utente in sessione ha un cono di
                            // visibilità minore
                            // Controlliamo anche lo smart filter per i casi in cui vengono aggiunti
                            // store nuovi successivamente alla creazione di una folder. In questo caso
                            // gli store nuovi non risultano nella lista esistente di store selezionati,
                            // ma in presenza dello smartFilter devono essere già selezionati
                            if (
                                selectAll ||
                                (isInit &&
                                    ((customStoreList &&
                                        form.selectedStoreList.value?.length >
                                            _data.stores.length) ||
                                        Object.keys(smartFilter || {}).length ||
                                        Object.keys(externalFilters || {}).length))
                            ) {
                                onAllRowsSelect(isInit)
                                return
                            }
                            setLoading(false)
                        }
                    }
                })
                .catch(() => setLoading(false))
        } else {
            setColumnFilters(
                !!lastFieldFilter
                    ? {
                          ...columnFilters,
                          [lastFieldFilter]: {
                              ...lazyParams.filters[lastFieldFilter],
                          },
                      }
                    : columnFilters
            )
        }
    }

    useEffect(() => {
        if (Object.keys(smartFilter || {}).length) {
            setShowDynamicFilter(true)
            setChecked(true)
            setSelectAll(true)
        }
    }, [smartFilter])

    useEffect(() => {
        setSelectAll(
            form.selectedStoreList.value?.length > 0 &&
                form.selectedStoreList.value.length === totalSelectedStores
        )
    }, [form.selectedStoreList.value])

    useEffect(() => {
        initStoreList(
            {
                ...lazyParams,
                filters: {
                    ...lazyParams.filters,
                    storeIdList: {
                        value: customStoreList || lazyParams.storeIdList,
                    },
                },
            },
            isInit
        )
        setIsInit(false)
    }, [lazyParams, customStoreList])

    useEffect(() => {
        // Da NewResources.tsx la customStoreList viene inizializzata diverse volte
        // Per capire quando cambia la customStoreList (e quindi il parent di subfolder o thread)
        // facciamo questo controllo, memorizzando la lughezza della prima lista che arriva
        // in localCustomStoreListLength
        if (!!customStoreList && customStoreList.length !== localCustomStoreListLength) {
            setLocalCustomStoreListLength(customStoreList.length)
            // Al cambio di customStoreList resettiamo gli store selezionati e lo smartFilter
            onSetForm({
                ...form,
                selectedStoreList: {
                    ...form.selectedStoreList,
                    value: [],
                },
            })
            setTotalSelectedStores(customStoreList.length)
            setSmartFilter({})
            setShowDynamicFilter(false)
            setChecked(false)
            onCloseFilters()
        }
    }, [customStoreList, localCustomStoreListLength])

    useEffect(() => {
        if (storesToImport?.length > 0) {
            let tmpSelectedRows = []
            tmpSelectedRows = storesToImport.filter((s: any) => storeIdList.includes(s))
            FiltersService.GetStoreList({
                mode: 'standard',
                coneOfVision: true,
                groupedFields: 'all',
                tableFilters: getDistributionFiltersBody({
                    storeIdList: { value: tmpSelectedRows },
                }),
            })
                .then(({ data }) => {
                    onSetForm({
                        ...form,
                        selectedStoreList: { ...form.selectedStoreList, value: data.stores ?? [] },
                    })
                })
                .finally(() => setLoading(false))
        }
    }, [storesToImport])

    useEffect(() => {
        const hasSmartFilter = Object.keys(smartFilter || {}).length
        const hasFilters = !!Object.values(getDistributionFiltersBody(lazyParams.filters)).filter(
            (f) => !!f
        ).length
        setShowDynamicFilter(
            !disableSmartFilters && ((selectAll && hasFilters) || !!hasSmartFilter)
        )
    }, [selectAll, lazyParams])

    useEffect(() => {
        getDistributionLists()
    }, [])

    const onChangeSmartFilter = () => {
        if (!checked) {
            setLazyParams((lp) => ({
                ...lp,
                filters: {
                    ...lp.filters,
                    ...setSmartFiltersOptions(columnFilters),
                },
            }))
            setColumnFilters((cf) => ({
                ...cf,
                ...setSmartFiltersOptions(columnFilters),
            }))
            setSmartFilter({
                bannerDesc:
                    (columnFilters ? columnFilters : lazyParams.filters).banner_desc.value || [],
                country: (columnFilters ? columnFilters : lazyParams.filters).country.value || [],
                macroregion:
                    (columnFilters ? columnFilters : lazyParams.filters).macroregion.value || [],
                region: (columnFilters ? columnFilters : lazyParams.filters).region.value || [],
                zoneDesc:
                    (columnFilters ? columnFilters : lazyParams.filters).zone_desc.value || [],
                host: (columnFilters ? columnFilters : lazyParams.filters).host.value || [],
                city: (columnFilters ? columnFilters : lazyParams.filters).city.value || [],
                storeLocation:
                    (columnFilters ? columnFilters : lazyParams.filters).store_location.value || [],
                storeHostName:
                    (columnFilters ? columnFilters : lazyParams.filters).store_host_name.value ||
                    [],
                businessModel:
                    (columnFilters ? columnFilters : lazyParams.filters).business_model.value || [],
                segment: (columnFilters ? columnFilters : lazyParams.filters).segment.value || [],
            })
        }
        if (checked) {
            setLazyParams((lp) => ({
                ...lp,
                filters: {
                    ...lp.filters,
                    ...getInitialFilters(filtersOptionsMap, {
                        ...lp.filters,
                        banner_desc: {
                            value: filtersOptionsMap?.bannerObject?.filter((b) =>
                                lp.filters.banner_desc?.value?.includes(b.code)
                            ),
                        },
                    }),
                },
            }))
            setColumnFilters((cf) => ({
                ...cf,
                ...getInitialFilters(filtersOptionsMap, {
                    ...cf,
                    banner_desc: {
                        value: filtersOptionsMap?.bannerObject?.filter((b) =>
                            cf.banner_desc?.value?.includes(b.code)
                        ),
                    },
                }),
            }))
            setSmartFilter({})
        }
        setChecked(!checked)
    }

    const onPage = (e: any) => {
        setLazyParams({
            ...lazyParams,
            first: e.first,
            page: e.page,
            rows: e.rows,
        })
    }

    const onChangeFilter = (filterValue, field) => {
        let value = filterValue
        // Unico caso in cui arriva un oggetto {label, value} lo abbiamo
        // quando eliminiamo un valore da un autocomplete multiselect (smartFilter)
        // In quel punto il componente primereact ci risponde con l'oggetto intero
        if (Array.isArray(filterValue) && filterValue[0]?.value) {
            value = filterValue.map((v) => v.value)
        }
        setLazyParams((lp) => ({
            ...lp,
            first: 0,
            page: 0,
            filters: {
                ...lp.filters,
                [!!lastFieldFilter && !!columnFilters ? lastFieldFilter : undefined]:
                    !!lastFieldFilter && !!columnFilters
                        ? {
                              ...lp.filters[lastFieldFilter],
                              value: columnFilters[lastFieldFilter].value,
                          }
                        : undefined,
                [field]: {
                    ...lp.filters[field],
                    value,
                },
            },
        }))
        setColumnFilters((cf) => ({
            ...cf,
            [field]: {
                ...cf[field],
                value,
            },
        }))
        setLastFieldFilter(!value || !value?.length ? null : field)
        if (checked) {
            setSmartFilter({
                ...smartFilter,
                [mappingSmartFilter[field]]: value,
            })
        }
    }

    const onSort = (e) => {
        setLazyParams((lazyParams) => ({
            ...lazyParams,
            page: 0,
            first: 0,
            sortField: e.sortField,
            sortOrder: e.sortOrder,
        }))
    }

    const onCloseFilters = () => {
        setLastFieldFilter(undefined)
        setLazyParams({
            first: 0,
            rows: lazyParams.rows,
            page: 0,
            sortField: 'store_id',
            sortOrder: 1,
            filters: {
                ...getInitialFilters(filtersOptionsMap),
            },
            storeIdList: customStoreList || [],
        })
        setColumnFilters({ ...getInitialFilters(filtersOptionsMap) })
    }

    const onAllRowsSelect = (isInit?: boolean) => {
        let storeIdList = {
            value: (isInit && externalFilters?.store) || customStoreList || lazyParams.storeIdList,
        }
        if (isInit && customStoreList && form.selectedStoreList?.value?.length) {
            storeIdList.value = form.selectedStoreList.value.map((s) => s.store_id)
        }
        setLoading(true)
        FiltersService.GetStoreList({
            mode: 'standard',
            coneOfVision: true,
            groupedFields: 'all',
            tableFilters: getDistributionFiltersBody({
                ...lazyParams.filters,
                storeIdList,
            }),
        })
            .then(({ data }) => {
                setSelectAll(true)
                onSetForm({
                    ...form,
                    selectedStoreList: { ...form.selectedStoreList, value: data.stores ?? [] },
                })
            })
            .finally(() => setLoading(false))
    }
    const onSelectedRows = (value: any) => {
        if (isReadOnly) {
            return null
        }

        if (mappingChanges && isEdit) {
            mappingChanges(value)
        }

        const newList = [...value]

        onSetForm({
            ...form,
            selectedStoreList: { ...form.selectedStoreList, value: newList ?? [] },
        })
    }

    const saveDistributionList = () => {
        props.saveDistributionList(
            form.listName.value,
            form.selectedStoreList.value?.map((store: any) => store.store_id)
        )
        if (onSave) onSave()
        onSetForm({ ...form, listName: { ...form.listName, value: '' } })
    }

    const onSelectionFilters = (filter: 'show_all' | 'show_selected' | 'show_unselected') => {
        onSetForm({
            ...form,
            listName: { value: '' },
            selectedDistributionList: { value: null },
        })

        // all
        let newStoreIdList = storeIdList
        // selected
        if (filter === 'show_selected') {
            newStoreIdList = form.selectedStoreList.value.map((s) => s.store_id)
        }
        // unselected
        if (filter === 'show_unselected') {
            const selectedStoreIds = new Set(form.selectedStoreList.value.map((s) => s.store_id))
            newStoreIdList = storeIdList.filter((s) => !selectedStoreIds.has(s))
        }
        setLazyParams({
            ...lazyParams,
            first: 0,
            page: 0,
            filters: { ...lazyParams.filters },
            storeIdList: newStoreIdList,
        })
    }

    const onSelectDistribution = (list) => {
        if (mappingChanges && isEdit) {
            mappingChanges(list.storesId.map((id) => ({ store_id: id })))
        }

        if (customStoreList) {
            onSetForm({
                ...form,
                selectedDistributionList: {
                    ...form.selectedDistributionList,
                    value: list,
                },
                selectedStoreList: {
                    ...form.selectedStoreList,
                    value: list.storesId?.length
                        ? list.storesId
                              .filter((s) => customStoreList.includes(s))
                              .map((id) => ({ store_id: id }))
                        : [],
                },
            })
            return
        }

        setLoading(true)
        FiltersService.GetStoreList({
            mode: 'standard',
            coneOfVision: true,
            groupedFields: 'all',
            tableFilters: {
                storeIdList: list.storesId,
            },
        })
            .then(({ data }) => {
                setSelectAll(data.stores.length === storeIdList.length)
                onSetForm({
                    ...form,
                    selectedDistributionList: {
                        ...form.selectedDistributionList,
                        value: list,
                    },
                    selectedStoreList: { ...form.selectedStoreList, value: data.stores ?? [] },
                })
            })
            .finally(() => setLoading(false))
    }

    let ctaTemplate = (
        <Fragment>
            <LuxButton
                loading={props.savingDistributionList}
                onClick={saveDistributionList}
                text={intl.formatMessage({
                    id: 'modals.new.activity.section.distribution.save',
                    defaultMessage: 'Save this store list',
                })}
                variant="outlined"
                disabled={!form.listName.value || !form.selectedStoreList.value?.length}
            />
        </Fragment>
    )
    if (isReadOnly || hideDistributionList) ctaTemplate = <></>

    const tableColumns =
        customColumnConfig ||
        columns(isMobile).map((column, index) => ({
            ...column,
            isMain: index === 2 && isMobile ? false : column.isMain,
            header: intl.formatMessage({
                id: column.header,
                defaultMessage: column.header.split('.').pop(),
            }),
            disabled: (column.field === 'store_name' || column.field === 'store_id') && checked,
            activeFilter: lazyParams.filters[column.field]?.value?.length > 0,
            filterType:
                column.field !== 'project_name' &&
                column.field !== 'project_id' &&
                checked &&
                showDynamicFilter
                    ? LUX_INPUT_TYPE.autocomplete
                    : column.filterType,
            multiple: checked && showDynamicFilter,
        }))

    const { reorderedColumns, setOrderColumns } = useTableConfig(tableConfigId, tableColumns)

    return (
        <>
            {children}
            <SectionItemContainer ctaTemplate={ctaTemplate}>
                <SectionItem>
                    {afterTableTemplate}
                    <LuxDataTable
                        id={`${componentClass}__datatable`}
                        classes={`${isReadOnly ? 'is-read-only' : ''} ${
                            disableSelection ? 'disable-selection' : ''
                        }`}
                        label={intl.formatMessage({
                            id: 'modals.new.activity.section.distribution.store.list',
                            defaultMessage: 'Store List',
                        })}
                        mandatory={true}
                        selectionMode={disableSelection ? null : 'multiple'}
                        columns={reorderedColumns}
                        dataSet={filteredStores}
                        scrollable
                        selectedRows={form.selectedStoreList.value}
                        setSelectedRows={(value) => onSelectedRows(value)}
                        totalRecords={totalStores}
                        totalSelectedRecords={totalSelectedStores}
                        onPage={onPage}
                        lazy
                        page={lazyParams.page}
                        first={lazyParams.first}
                        rows={lazyParams.rows}
                        dataKey="store_id"
                        columnFilters={columnFilters}
                        onFilterChange={onChangeFilter}
                        onSort={onSort}
                        sortField={lazyParams.sortField}
                        sortOrder={lazyParams.sortOrder}
                        onCloseFilters={onCloseFilters}
                        // onAllRowsSelect explicit invoking to avoid event first param
                        onAllRowsSelect={() => onAllRowsSelect()}
                        onAllRowsUnselect={() => {
                            setSelectAll(false)
                        }}
                        onDownload={() => setShowDialogDownloadList(true)}
                        checked={checked}
                        onChangeSmartFilter={onChangeSmartFilter}
                        showDynamicFilter={showDynamicFilter}
                        fixedFilters={!disableFixedFilters}
                        selectionFilters={selectionFilters}
                        rearrangeColumns
                        loading={loading}
                        containerClassName={
                            checked
                                ? `${componentClass}__datatable smart-filter-on`
                                : `${componentClass}__datatable`
                        }
                        headerActions={
                            disableHeaderActions
                                ? []
                                : [
                                      {
                                          text: intl.formatMessage({
                                              id: 'modals.new_resource.distribution.store_list.upload',
                                              defaultMessage: 'Upload',
                                          }),
                                          iconLeft: 'upload',
                                          onClick: () => setShowDialogUploadList(true),
                                      },
                                      {
                                          text: intl.formatMessage({
                                              id: 'modals.new_resource.distribution.store_list.export_template',
                                              defaultMessage: 'Export template',
                                          }),
                                          iconLeft: 'template',
                                          onClick: () => setShowDialogExportTemplate(true),
                                      },
                                  ]
                        }
                        onColumnReorder={setOrderColumns}
                        labels={{
                            filter: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.filter',
                                defaultMessage: 'filter',
                            }),
                            rearrange: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.rearrange',
                                defaultMessage: 'rearrange',
                            }),
                            of: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.labels.of',
                                defaultMessage: 'of',
                            }),
                            selected: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.labels.selected',
                                defaultMessage: 'selected',
                            }),
                            emptyMessage: intl.formatMessage({
                                id: 'modals.new_resource.distribution.store_list.labels.emptyMessage',
                                defaultMessage: 'No results to show.',
                            }),
                            smartFilterLabel: intl.formatMessage({
                                id: 'modals.filters.smart.filter',
                                defaultMessage: 'Smart Filter',
                            }),
                            smartFilterBanner: intl.formatMessage({
                                id: 'modals.filters.smart.filter.banner',
                                defaultMessage:
                                    'The Smart Filter selection automatically updates all new stores within the chosen perimeter.',
                            }),
                            smartFilterOverlay: intl.formatMessage({
                                id: 'modals.filters.smart.filter.overlay',
                                defaultMessage:
                                    "Smart filtering is now available because you have 'Select All' and at least one filter active in the Store list.",
                            }),
                        }}
                        disablePredictionSelected
                    />
                </SectionItem>
                {beforeTableTemplate}
                {!isReadOnly && !hideDistributionList && (
                    <SectionItem>
                        <div className={`${componentClass}__input-wrapper`}>
                            <LuxSelect
                                value={form.selectedDistributionList.value}
                                disabled={
                                    form.selectedDistributionList.disabled ||
                                    gettingDistributionList
                                }
                                onChangeCallback={onSelectDistribution}
                                label={intl.formatMessage({
                                    id: 'modals.new.activity.section.distribution.list.selected',
                                    defaultMessage: 'Distribution List',
                                })}
                                options={distributionLists}
                                placeholder={intl.formatMessage({
                                    id: 'modals.new.activity.section.distribution.list.selected.placeholder',
                                    defaultMessage: 'Select distribution list',
                                })}
                                additionalProps={{
                                    appendTo: 'self',
                                    optionLabel: 'name',
                                }}
                            />
                            <LuxTextInput
                                value={form.listName.value}
                                disabled={form.listName.disabled}
                                onChangeCallback={(value) =>
                                    onSetForm({ ...form, listName: { ...form.listName, value } })
                                }
                                label={intl.formatMessage({
                                    id: 'modals.new.activity.section.distribution.list.name',
                                    defaultMessage: 'Survey title',
                                })}
                                placeholder={intl.formatMessage({
                                    id: 'modals.new.activity.section.distribution.list.name.placeholder',
                                    defaultMessage: 'Type here...',
                                })}
                                style={{ backgroundColor: Color.WHITE }}
                            />
                        </div>
                    </SectionItem>
                )}
                <DialogDownloadList
                    dialogVisible={showDialogDownloadList}
                    onSave={() => {
                        props.downloadStoreList(
                            'standard',
                            form?.selectedStoreList?.value.map((store) => store.store_id) ||
                                undefined
                        )
                        setShowDialogDownloadList(false)
                    }}
                    onHide={() => {
                        setShowDialogDownloadList(false)
                    }}
                />
                <DialogUploadList
                    dialogVisible={showDialogUploadList}
                    onSave={(e: any) => onUploadList(e)}
                    onHide={() => {
                        setStoresToImport([])
                        setShowDialogUploadList(false)
                    }}
                />
                <DialogExportTemplate
                    dialogVisible={showDialogExportTemplate}
                    onSave={onExportTemplate}
                    onHide={() => {
                        setShowDialogExportTemplate(false)
                    }}
                />
            </SectionItemContainer>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    storeIdList: state[FILTERS_REDUCER_NAMESPACE].storeIdList,
    distributionLists: state[FILTERS_REDUCER_NAMESPACE].distributionLists,
    savingDistributionList: state[FILTERS_REDUCER_NAMESPACE].savingDistributionList,
    gettingDistributionLists: state[FILTERS_REDUCER_NAMESPACE].gettingDistributionLists,
    gettingDistributionList: state[FILTERS_REDUCER_NAMESPACE].gettingDistributionList,
    filtersOptionsMap: state[DISTRIBUTION_REDUCER_NAMESPACE].filtersOptionsMap,
    isEdit: state.layoutReducer.modals.props?.isEdit,
})

const mapDispatchToProps = (dispatch: any) => ({
    setStoreIdList: (value: any[]) => dispatch(setStoreIdList(value)),
    getDistributionLists: () => dispatch(getDistributionLists()),
    saveDistributionList: (name: string, storesId: any[]) =>
        dispatch(saveDistributionList(name, storesId)),
    downloadStoreList: (mode, storeIdList) => dispatch(downloadStoreList(mode, storeIdList)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DistributionList)
